import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { getPhones } from "../api/phones.js";
import { withQueryParams } from "../helpers/common.js";
import { secondsToMs } from "../helpers/time.js";
import { useAxiosProvider } from "../providers/AxiosProvider.js";
import "react/jsx-runtime";
import "axios";
const usePhones = (hasPhones, clinicReferenceId) => {
  const axios = useAxiosProvider();
  const queryKey = useMemo(() => ["phones", clinicReferenceId], [clinicReferenceId]);
  return useQuery({
    queryKey,
    queryFn: withQueryParams(getPhones(axios)),
    enabled: Boolean(clinicReferenceId) && !hasPhones,
    staleTime: secondsToMs(60)
  });
};
export {
  usePhones
};
